import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import {useAuth} from '../context/auth';
import useSeo from "../components/seo";
import {AppRoutes} from "../utils/constants";

function GuestRoute ({ component: Component, title, noRedirect, ...rest }) {
  let {authenticated} = useAuth();
  const location = useLocation();

  // Use the layout defined at the page level, if available
  const getLayout = Component.getLayout || ((page) => page);
  const appWithLayout = getLayout(<Component {...rest} />);

  //set the meta params
  const getSEO = Component.getSEO || (()=>{});
  useSeo(getSEO());

  return (
    authenticated && !noRedirect ? <Navigate to={AppRoutes.home.path} replace state={{from: location}} />
      : appWithLayout
  )
}

GuestRoute.displayName = 'Guest Route';

GuestRoute.propTypes = {
  component: PropTypes.func.isRequired,
  rest: PropTypes.object,
  location: PropTypes.object,
  title: PropTypes.string,
  noRedirect: PropTypes.bool
};

export default GuestRoute;
